import ComponentSettings from "./ComponentSettings";

export default ComponentSettings;